export { searchByKeyword, searchArticle, findClass1byObj, findClass2byClass1, findItembySubclassId }

import axios from "axios";

function demo() {
    console.log('1111')
    return new Promise((resolve, reject) => {

    })
}

//根据关键字查询所有事项
function searchByKeyword(searchContent, pageNum) {
    //接口返回的数据总条目数 数字
    let resTotal;
    //接口返回的总内容列表 数组
    let list;
    //要返回的对象
    let data = {
        totalItem: -1,
        itemList: []
    }
    return new Promise((resolve, reject) => {
        axios({
            methods: "get",
            url: "https://jwgf.henu.edu.cn:443/seacher/queryAll/" +
                searchContent +
                "/" +
                pageNum,
        }).then((res) => {
            console.log('根据关键字查询的接口调取成功')
                // console.log(res.data);
            resTotal = res.data[res.data.length - 1];
            // console.log("总数据数", resTotal.sum);

            res.data.pop();
            // console.log(res.data);
            list = res.data;

            data.totalItem = resTotal.sum
            data.itemList = list

            // console.log(data);
            // return data
            resolve(data)
        });

    })

}


//根据事项id查询事项具体内容
function searchArticle(articleId) {


    return new Promise((resolve, reject) => {
        axios({
            methods: "get",
            url: "https://jwgf.henu.edu.cn:443/seacher/queryOneBusinessWithId/" + articleId,
        }).then((res) => {
            resolve(res.data)
        });
    })

}


//根据对象查询所有的一级标题
function findClass1byObj(role) {

    return new Promise((resolve, reject) => {
        axios({
            methods: "get",
            url: "https://jwgf.henu.edu.cn:443/class/queryClassAndSubcla/" + role,
        }).then((res) => {
            resolve(res.data)
        });
    })

}


//根据一级标题查询二级标题
function findClass2byClass1(Class1Id) {

    return new Promise((resolve, reject) => {
        axios({
            methods: "get",
            url: "https://jwgf.henu.edu.cn:443/subclass/queryAllSubClass/" + Class1Id,
        }).then((res) => {
            resolve(res.data)
        });
    })

}


//根据二级标题查询所有事项
function findItembySubclassId(subclassId, role, currentPage) {

    //返回的总数据数 数字
    let totalItem
        //数据存储在该列表
    let contentList
        //经过处理后的数据
    let data = {
        totalItem: -1,
        contentList: []
    }

    return new Promise((resolve, reject) => {

        axios({
            methods: "get",
            url: "https://jwgf.henu.edu.cn:443/seacher/query/" +
                subclassId +
                "/" +
                role +
                "/" +
                currentPage,
        }).then((res) => {
            let resTotal = res.data[res.data.length - 1];
            totalItem = resTotal.sum;
            res.data.pop();
            contentList = res.data;

            data.totalItem = totalItem
            data.contentList = contentList

            resolve(data)

        });

    })

}